/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { albumModelSchema } from "./albumModelSchema.ts";
import { z } from "zod";

export const albumModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => albumModelSchema))
    })